// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-2Dvsw";
var _3 = "label-zMQPb";
var _4 = "labelPosition__left-3xlqM";
var _5 = "labelPosition__right-2XSrp";
var _6 = "disabled-1Faok";
var _7 = "toggle-1cqko";
var _8 = "loading-gkmKl";
var _9 = "required-3ZNHz";
var _a = "checked-1CG9u";
var _b = "inverted-13VbL";
var _c = "handle-2KKJo";
var _d = "handle__circular-FFbHm";
var _e = "handle__circular_progress-WNakZ";
export { _1 as "__esModule", _2 as "root", _3 as "label", _4 as "labelPosition__left", _5 as "labelPosition__right", _6 as "disabled", _7 as "toggle", _8 as "loading", _9 as "required", _a as "checked", _b as "inverted", _c as "handle", _d as "handle__circular", _e as "handle__circular_progress" }
export default { "__esModule": _1, "root": _2, "label": _3, "labelPosition__left": _4, "labelPosition__right": _5, "disabled": _6, "toggle": _7, "loading": _8, "required": _9, "checked": _a, "inverted": _b, "handle": _c, "handle__circular": _d, "handle__circular_progress": _e }
